import React, { useState } from 'react';
import { Form, Modal, Radio, RadioChangeEvent } from 'antd';
import { ButtonCommon, InputCommon } from 'components/common';
import { useLazyGetAllReturnOrdersQuery } from 'services/returnOrder.service';

interface SelectReturnOptionProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (id: string) => void;
}

const SelectReturnOption: React.FC<SelectReturnOptionProps> = ({ isOpen, onCancel, onConfirm }) => {
  const [returnType, setReturnType] = useState<string>('');
  const [selectedCode, setSelectedCode] = useState<string>('');
  const [getOrder, { isLoading }] = useLazyGetAllReturnOrdersQuery();
  const [form] = Form.useForm();
  function handleSelect(e: RadioChangeEvent): void {
    setReturnType(e.target.value);
    setSelectedCode('');
  }
  const handleConfirm = async () => {
    if (returnType === 'individual') {
      onConfirm('');
    } else {
      const response = await getOrder({
        query: {
          filter: 'code:eq:' + selectedCode + '&&type:in:["purchase-order","order-supplier"]',
          include: 'inventoryDocumentItems',
        },
      });
      if (response.data && response.data.data.rows.length > 0 && response.data.data.rows[0].id) {
        if (response.data.data.rows[0].inventoryDocumentItems?.length === 0) {
          if (returnType === 'import') {
            form.setFields([
              {
                name: 'codePurchase',
                errors: ['Phiếu nhập hàng này không có sản phẩm nào'],
              },
            ]);
          }
          if (returnType === 'purchase') {
            form.setFields([
              {
                name: 'codeOrder',
                errors: ['Phiếu đặt hàng này không có sản phẩm nào'],
              },
            ]);
          }
        } else onConfirm(response.data.data.rows[0].id);
      } else {
        if (returnType === 'import') {
          form.setFields([
            {
              name: 'codePurchase',
              errors: ['Mã phiếu nhập hàng không tồn tại'],
            },
          ]);
        }
        if (returnType === 'purchase') {
          form.setFields([
            {
              name: 'codeOrder',
              errors: ['Mã đơn đặt hàng không tồn tại'],
            },
          ]);
        }
      }
    }
  };
  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      width={682}
      centered
      className='select-return-option-modal'
      closeIcon={null}
    >
      <div className='bg-white rounded-lg flex flex-col overflow-hidden'>
        <Form form={form} layout='vertical'>
          <div className='px-6 py-3'>
            <div className='text-black text-xl font-bold leading-normal mb-1'>CHỌN ĐƠN HÀNG CẦN TRẢ</div>
            <div className='text-zinc-500 text-sm font-normal leading-tight'>
              Vui lòng chọn đơn hàng cần trả thông qua mã đơn, nếu không trả theo đơn nhập thì có thể tạo mới để chọn
              sản phẩm trả
            </div>
          </div>
          <div className='px-6 bg-[var(--bgGreyColor)] flex flex-col gap-3 py-4'>
            <Radio.Group
              onChange={handleSelect}
              value={returnType}
              className='w-full flex flex-col gap-3 custom-radio radio-border-primary custom-group-radio'
            >
              <Radio value='import' className='w-full rounded-xl p-4 !border-[var(--textBlack12)] border bg-white'>
                <div>
                  <div className='font-medium'>Trả hàng theo mã phiếu nhập hàng</div>
                  <div className='text-sm text-[var(--textBlack56)]'>
                    Bạn cần nhập hoặc chọn chính xác mã phiếu nhập để trả hàng
                  </div>
                  {returnType === 'import' && (
                    <div className='mt-3'>
                      {/* <SelectCommon
                      placeholderSelect='Chọn mã đơn hàng...'
                      className='bg-white'
                      value={selectedCode}
                      selectType='filterSelect'
                      options={data?.data.rows
                        .filter((order) => order.type === 'purchase-order')
                        .map((order) => ({
                          label: order.code,
                          value: order.code,
                        }))}
                      loading={isLoading}
                      onChange={(value) => setSelectedCode(value)}
                    /> */}
                      <Form.Item name='codePurchase' className='mb-0'>
                        <InputCommon
                          placeholder='Nhập mã phiếu nhập hàng...'
                          className='bg-white'
                          value={selectedCode}
                          onChange={(e) => setSelectedCode(e.target.value)}
                        />
                      </Form.Item>
                    </div>
                  )}
                </div>
              </Radio>

              <Radio value='purchase' className='w-full rounded-xl p-4 !border-[var(--textBlack12)] border bg-white'>
                <div>
                  <div className='font-medium'>Trả hàng theo đơn đặt hàng từ NCC</div>
                  <div className='text-sm text-[var(--textBlack56)]'>
                    Bạn cần nhập hoặc chọn chính xác mã đơn đặt hàng để trả hàng
                  </div>
                  {returnType === 'purchase' && (
                    <div className='mt-3'>
                      <Form.Item name='codeOrder' className='mb-0'>
                        <InputCommon
                          placeholder='Nhập mã phiếu đặt hàng...'
                          className='bg-white'
                          value={selectedCode}
                          onChange={(e) => setSelectedCode(e.target.value)}
                        />
                      </Form.Item>
                    </div>
                  )}
                </div>
              </Radio>

              <Radio value='individual' className='w-full rounded-xl p-4 !border-[var(--textBlack12)] border bg-white'>
                <div>
                  <div className='font-medium'>Trả hàng lẻ, không có trong đơn hàng</div>
                  <div className='text-sm text-[var(--textBlack56)]'>Bạn có thể chọn lẻ từng sản phẩm để trả</div>
                </div>
              </Radio>
            </Radio.Group>

            <div className='flex justify-center gap-6 mt-2 mb-2'>
              <ButtonCommon color='none' size='sm' radius='rounded' onClick={onCancel}>
                Huỷ
              </ButtonCommon>
              <ButtonCommon
                color='primary'
                size='sm'
                radius='rounded'
                onClick={handleConfirm}
                isDisabled={!returnType || (returnType !== 'individual' && !selectedCode)}
                loading={isLoading}
              >
                Xác nhận
              </ButtonCommon>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default SelectReturnOption;
